<h1 mat-dialog-title>Error</h1>
<div mat-dialog-content>
  <p>Ocurrió un error al intentar obtener los turnos del calendario.</p>
</div>
